import { Pagination, Tab, Tabs } from "@mui/material";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "../../../../components/Loader";
import fetchApi from "../../../../utils/fetchApi";

export default function ChallengeCategory() {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);
  const [categoryData, setCategoryData] = useState();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState();
  const [subscriber, setSubscriber] = useState(0);
  const [selectedTab, setSelectedTab] = useState(1);

  const [toBeToggledCat, setToBeToggledCat] = useState({});

  useEffect(() => {
    setIsLoading(true);
    (async () => {
      try {
        const data = await fetchApi(
          "GET",
          `${
            window?.location?.origin?.includes("localhost")
              ? `${process.env.REACT_APP_DEV_URL}`
              : `${process.env.REACT_APP_API_URL}`
          }/organizations/event-categories`,
          {
            headers: {},
            params: {
              orgId: localStorage.getItem("orgId"),
              page,
              limit: pageSize,
            },
          }
        );
        // Sort the items based on the isActive property
        const sortedItems = data?.data?.items?.sort((a, b) => {
          return b.isActive - a.isActive; // true (1) will be placed before false (0)
        });

        setCategoryData(sortedItems);
        setTotalPages(
          Math.ceil(data?.data?.meta?.total / data?.data?.meta?.pageSize)
        );
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    })();
  }, [page, subscriber, pageSize]);

  const deactiveCategory = async () => {
    setIsLoading(true);
    try {
      await fetchApi(
        "PATCH",
        `${
          window?.location?.origin?.includes("localhost")
            ? `${process.env.REACT_APP_DEV_URL}`
            : `${process.env.REACT_APP_API_URL}`
        }/organizations/event-categories/${toBeToggledCat?.id}`,
        {
          headers: {},
          data: {
            isActive: !toBeToggledCat?.isActive,
          },
          params: {
            orgId: localStorage?.getItem("orgId"),
          },
        }
      );
      toast.success("وضعیت دسته‌بندی با موفقیت تغییر یافت.");
      setSubscriber(prev => prev + 1);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const handleChangeTabs = (event, newValue) => {
    setSelectedTab(newValue);
  };

  return (
    <div
      className={`w-full flex flex-col justify-between h-[calc(100vh-192px)] overflow-y-auto scrollBar`}
    >
      {isLoading ? (
        <Loader />
      ) : (
        <div
          className={`w-full flex flex-col justify-between h-full max-lg:gap-10`}
        >
          <div className={`w-full flex items-center justify-center lg:hidden`}>
            <Tabs
              className={`min-w-[50%] [&>div>div>button]:transition-all [&>div>div>button]:z-[2] [&>div>div>button.MuiTab-root.Mui-selected]:text-white [&>div>div>button]:text-myNavyBlue [&>div>div>button]:min-h-[48px] [&>div>div>button]:max-h-[48px] [&>div>.MuiTabs-indicator]:!h-full [&>div>.MuiTabs-indicator]:bg-myLightBlue [&>div>.MuiTabs-indicator]:rounded-xl p-1 border-2 border-myLightBlue rounded-xl`}
              value={selectedTab}
              onChange={handleChangeTabs}
              aria-label="basic tabs example"
            >
              <Tab
                className={`${
                  selectedTab === 1
                    ? "bg-myBlue257 text-white z-50"
                    : "bg-white text-[#ADADAD]"
                } w-1/2 rounded-lg h-[30px]`}
                label={`دسته‌بندی چالش`}
                value={1}
              />

              <Tab
                className={`${
                  selectedTab === 2
                    ? "bg-myBlue257 text-white"
                    : "bg-white text-[#ADADAD]"
                } w-1/2 rounded-lg h-[30px]`}
                label={`چالش‌ها`}
                onClick={() => navigate(`/dashboard/challenges`)}
                value={2}
              />
            </Tabs>
          </div>
          <div className={`flex flex-col gap-11`}>
            <div className={`flex justify-between items-center px-4`}>
              <div className={`flex items-center gap-4 max-lg:hidden`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M8.93263 10.4746C8.83627 10.465 8.72064 10.465 8.61464 10.4746C6.32123 10.3976 4.5 8.5185 4.5 6.20582C4.5 3.84496 6.40796 1.92737 8.77846 1.92737C11.1393 1.92737 13.0569 3.84496 13.0569 6.20582C13.0473 8.5185 11.226 10.3976 8.93263 10.4746Z"
                    stroke="#414A53"
                    strokeWidth="1.44542"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M15.9192 3.85437C17.7886 3.85437 19.2919 5.36725 19.2919 7.22703C19.2919 9.04826 17.8464 10.5322 16.0445 10.5997C15.9674 10.59 15.8807 10.59 15.7939 10.5997"
                    stroke="#414A53"
                    strokeWidth="1.44542"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M4.11469 14.0302C1.78273 15.5913 1.78273 18.1352 4.11469 19.6866C6.76463 21.4597 11.1105 21.4597 13.7605 19.6866C16.0924 18.1256 16.0924 15.5816 13.7605 14.0302C11.1202 12.2668 6.77427 12.2668 4.11469 14.0302Z"
                    stroke="#414A53"
                    strokeWidth="1.44542"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M17.7783 19.2724C18.4721 19.1279 19.1274 18.8484 19.667 18.4341C21.1702 17.3066 21.1702 15.4469 19.667 14.3194C19.137 13.9147 18.4914 13.6449 17.8072 13.4907"
                    stroke="#414A53"
                    strokeWidth="1.44542"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <span className={`text-myBlack414 text-lg font-semibold`}>
                  دسته‌بندی چالش‌ها
                </span>
              </div>
              <div
                className={`flex items-center gap-6 max-lg:w-full max-lg:justify-end`}
              >
                {localStorage.getItem("role") === "SUPER_ADMIN" && (
                  <Link to={`new`}>
                    <button
                      className={`btn bg-myBlue257 hover:bg-myBlue257 hover:scale-105 rounded-lg text-myNeutral font-bold max-lg:hidden`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="15"
                        height="14"
                        viewBox="0 0 15 14"
                        fill="none"
                      >
                        <path
                          d="M7.84912 12.6415V1.15771"
                          stroke="white"
                          strokeWidth="1.59476"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M13.7512 6.89935L1.55011 6.89935"
                          stroke="white"
                          strokeWidth="1.59476"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      ثبت دسته‌بندی جدید
                    </button>
                  </Link>
                )}
                <select
                  value={pageSize}
                  onChange={e => setPageSize(e.target.value)}
                  className="select border-[#98A2B3]"
                >
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                </select>
              </div>
            </div>
            <div className="overflow-x-auto max-h-[500px] relative">
              <table className="table table-pin-rows">
                {/* head */}
                <thead className="sticky top-0 z-40">
                  <tr className={`border-b-myNeutralBorder bg-white`}>
                    <th
                      className={`text-myNeutralBody text-center max-lg:sticky max-lg:right-0 max-lg:z-30 max-lg:bg-white max-lg:min-w-[70px]`}
                    >
                      ردیف
                    </th>
                    <th
                      className={`text-myNeutralBody text-center max-lg:sticky max-lg:right-[70px] max-lg:z-20 max-lg:bg-white`}
                    >
                      نام دسته‌بندی چالش
                    </th>
                    <th className={`text-myNeutralBody text-center`}>شاخص</th>
                    <th className={`text-myNeutralBody text-center`}>
                      واحد اندازه‌گیری شاخص
                    </th>
                    <th className={`text-myNeutralBody text-center`}>
                      ثبت چالش توسط اعضا
                    </th>
                    <th className={`text-myNeutralBody text-center`}>
                      ثبت اطلاعات
                    </th>
                    <th className={`text-myNeutralBody text-center`}>وضعیت</th>
                    {localStorage.getItem("role") === "SUPER_ADMIN" && (
                      <th className={`text-myNeutralBody text-center`}>
                        عملیات
                      </th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {/* row 1 */}
                  {categoryData?.map((itm, i) => (
                    <tr
                      key={i}
                      className={`border-b-myNeutralBorder [&>td]:text-center`}
                    >
                      <th
                        className={`text-center max-lg:sticky max-lg:right-0 max-lg:z-30 max-lg:bg-white max-lg:min-w-[70px]`}
                      >
                        {i + 1}
                      </th>
                      <th
                        className={`max-lg:sticky max-lg:right-[70px] max-lg:z-20 max-lg:bg-white`}
                      >
                        <div
                          className={`flex justify-center items-center gap-2`}
                        >
                          {/* <label>
                            <input
                              type="checkbox"
                              className="checkbox checkbox-info border-myNeutralCaption [--chkfg:white]"
                            />
                          </label> */}
                          <span
                            className={`text-myNeutralTitle max-lg:whitespace-nowrap`}
                          >
                            {itm?.name}
                          </span>
                        </div>
                      </th>
                      <td
                        className={`text-myNeutralTitle max-lg:whitespace-nowrap`}
                      >
                        {itm?.indicator}
                      </td>
                      <td className={`text-myNeutralTitle`}>
                        {itm?.indicatorMeasurementUnit}
                      </td>
                      <td className={`text-myNeutralTitle`}>
                        {itm?.employeeCreateEvent ? "بله" : "خیر"}
                      </td>
                      <td
                        className={`text-myNeutralTitle max-lg:whitespace-nowrap`}
                      >
                        {itm?.type?.dataEntryType === "ADMIN"
                          ? "ادمین"
                          : itm?.type?.dataEntryType === "SYSTEM"
                          ? "سیستم"
                          : "اسکن/ورود کد"}
                      </td>
                      <td className={`text-myNeutralTitle`}>
                        {itm?.isActive ? "فعال" : "غیرفعال"}
                      </td>
                      {localStorage?.getItem("role") === "SUPER_ADMIN" && (
                        <th className={`text-center`}>
                          <div
                            className={`flex items-center justify-center gap-2`}
                          >
                            <Link to={`new/${itm?.id}`}>
                              <button
                                className={`btn btn-square btn-sm bg-[#FFF0B9] hover:bg-[#FFF0B9]`}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="14"
                                  height="14"
                                  viewBox="0 0 14 14"
                                  fill="none"
                                >
                                  <path
                                    d="M8.21013 12.6254H4.92843C1.9585 12.6254 0.689575 11.3565 0.689575 8.38652V5.10483C0.689575 2.13489 1.9585 0.865967 4.92843 0.865967H6.02233C6.24658 0.865967 6.43255 1.05193 6.43255 1.27618C6.43255 1.50043 6.24658 1.68639 6.02233 1.68639H4.92843C2.407 1.68639 1.51 2.58339 1.51 5.10483V8.38652C1.51 10.908 2.407 11.805 4.92843 11.805H8.21013C10.7316 11.805 11.6286 10.908 11.6286 8.38652V7.29262C11.6286 7.06837 11.8145 6.88241 12.0388 6.88241C12.263 6.88241 12.449 7.06837 12.449 7.29262V8.38652C12.449 11.3565 11.1801 12.6254 8.21013 12.6254Z"
                                    fill="#FBBC05"
                                  />
                                  <path
                                    d="M4.65496 9.85798C4.32132 9.85798 4.01503 9.73765 3.79078 9.51887C3.52277 9.25087 3.40791 8.86253 3.46808 8.45232L3.70327 6.806C3.74702 6.48877 3.95486 6.07856 4.17911 5.85431L8.48907 1.54435C9.5775 0.45592 10.6823 0.45592 11.7708 1.54435C12.3669 2.14052 12.635 2.74764 12.5803 3.35475C12.531 3.84701 12.2685 4.32832 11.7708 4.82058L7.46081 9.13054C7.23656 9.35479 6.82635 9.56263 6.50912 9.60639L4.8628 9.84157C4.7917 9.85798 4.72059 9.85798 4.65496 9.85798ZM9.06884 2.12412L4.75888 6.43408C4.65496 6.538 4.53463 6.77866 4.51275 6.92086L4.27756 8.56718C4.25568 8.7258 4.2885 8.85706 4.37054 8.93911C4.45259 9.02115 4.58385 9.05397 4.74247 9.03209L6.38879 8.7969C6.531 8.77502 6.77712 8.65469 6.87557 8.55077L11.1855 4.24081C11.5411 3.88529 11.727 3.56806 11.7544 3.27271C11.7872 2.91719 11.6012 2.5398 11.1855 2.11865C10.3104 1.24353 9.70877 1.48965 9.06884 2.12412Z"
                                    fill="#FBBC05"
                                  />
                                  <path
                                    d="M10.8628 5.5589C10.8245 5.5589 10.7863 5.55344 10.7534 5.5425C9.31496 5.13775 8.17184 3.99463 7.76709 2.55615C7.70693 2.33737 7.83273 2.11312 8.05151 2.04749C8.27029 1.98732 8.49454 2.11312 8.5547 2.3319C8.88287 3.49691 9.80721 4.42125 10.9722 4.74942C11.191 4.80958 11.3168 5.0393 11.2566 5.25808C11.2074 5.44405 11.0433 5.5589 10.8628 5.5589Z"
                                    fill="#FBBC05"
                                  />
                                </svg>
                              </button>
                            </Link>

                            <button
                              className="btn btn-ghost btn-sm btn-square bg-myBrandRed hover:bg-myBrandRed"
                              onClick={() => {
                                document
                                  .getElementById("deactive_modal")
                                  .showModal();
                                setToBeToggledCat(itm);
                              }}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="15"
                                height="15"
                                viewBox="0 0 15 15"
                                fill="none"
                              >
                                <path
                                  d="M13.182 4.56226C13.17 4.56226 13.1518 4.56226 13.1337 4.56226C9.93832 4.24211 6.74895 4.1213 3.58978 4.44145L2.35752 4.56226C2.10382 4.58642 1.88033 4.4052 1.85616 4.1515C1.832 3.8978 2.01322 3.68035 2.26088 3.65619L3.49313 3.53538C6.70666 3.20919 9.96248 3.33604 13.2243 3.65619C13.472 3.68035 13.6532 3.90385 13.629 4.1515C13.6109 4.38708 13.4116 4.56226 13.182 4.56226Z"
                                  fill="#EA4335"
                                />
                                <path
                                  d="M5.63158 3.95229C5.60742 3.95229 5.58326 3.95229 5.55306 3.94625C5.31144 3.90396 5.14231 3.66839 5.18459 3.42677L5.31748 2.63547C5.41413 2.05558 5.54702 1.2522 6.95445 1.2522H8.53705C9.95052 1.2522 10.0834 2.08578 10.174 2.64151L10.3069 3.42677C10.3492 3.67443 10.1801 3.91 9.93844 3.94625C9.69078 3.98853 9.4552 3.8194 9.41896 3.57778L9.28607 2.79252C9.2015 2.267 9.18338 2.16431 8.54309 2.16431H6.96049C6.3202 2.16431 6.30812 2.24888 6.21751 2.78648L6.07858 3.57174C6.04234 3.79524 5.84904 3.95229 5.63158 3.95229Z"
                                  fill="#EA4335"
                                />
                                <path
                                  d="M9.68474 14.2391H5.80675C3.69863 14.2391 3.61406 13.0733 3.54762 12.131L3.15499 6.04824C3.13686 5.80058 3.33016 5.58313 3.57782 5.56501C3.83152 5.55293 4.04294 5.74018 4.06106 5.98784L4.45369 12.0706C4.52013 12.9887 4.54429 13.3331 5.80675 13.3331H9.68474C10.9532 13.3331 10.9774 12.9887 11.0378 12.0706L11.4304 5.98784C11.4486 5.74018 11.666 5.55293 11.9137 5.56501C12.1613 5.58313 12.3546 5.79454 12.3365 6.04824L11.9439 12.131C11.8774 13.0733 11.7929 14.2391 9.68474 14.2391Z"
                                  fill="#EA4335"
                                />
                                <path
                                  d="M8.74845 10.9168H6.73697C6.48931 10.9168 6.28394 10.7114 6.28394 10.4638C6.28394 10.2161 6.48931 10.0107 6.73697 10.0107H8.74845C8.99611 10.0107 9.20148 10.2161 9.20148 10.4638C9.20148 10.7114 8.99611 10.9168 8.74845 10.9168Z"
                                  fill="#EA4335"
                                />
                                <path
                                  d="M9.25568 8.5008H6.23545C5.98779 8.5008 5.78241 8.29542 5.78241 8.04776C5.78241 7.8001 5.98779 7.59473 6.23545 7.59473H9.25568C9.50334 7.59473 9.70872 7.8001 9.70872 8.04776C9.70872 8.29542 9.50334 8.5008 9.25568 8.5008Z"
                                  fill="#EA4335"
                                />
                              </svg>
                            </button>
                          </div>
                        </th>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Deactive Challenge Category */}
          <dialog id="deactive_modal" className={`modal`}>
            <div className="modal-box bg-white">
              <div className={`flex flex-col items-center gap-10`}>
                <span
                  className={`text-sm lg:text-lg max-lg:text-center font-medium`}
                >
                  آیا از تغییر وضعیت این دسته‌بندی مطمئن هستید؟
                </span>
                <form
                  method="dialog"
                  className={`w-full lg:max-w-36 h-12 rounded-xl flex justify-between lg:justify-center items-center gap-4 lg:gap-8`}
                >
                  <button
                    onClick={deactiveCategory}
                    className={`btn bg-myGreen34A hover:bg-myGreen34A rounded-lg font-bold text-white w-[calc(50%-8px)] lg:w-[182px]`}
                    style={{ border: "1px solid" }}
                  >
                    بله
                  </button>
                  <button
                    className={`btn bg-[#EA4335] hover:bg-[#EA4335] rounded-lg font-bold text-white w-[calc(50%-8px)] lg:w-[182px]`}
                    style={{ border: "1px solid" }}
                  >
                    خیر
                  </button>
                </form>
              </div>
            </div>
            <form method="dialog" className="modal-backdrop">
              <button>close</button>
            </form>
          </dialog>

          <div className={`w-full flex justify-center items-center`}>
            {totalPages > 1 && (
              <Pagination
                count={totalPages}
                page={page}
                onChange={(e, value) => setPage(value)}
                dir="ltr"
                variant="outlined"
                size="large"
                hideNextButton={true}
                hidePrevButton={true}
                sx={{
                  button: {
                    borderColor: "#257BC1",
                    "&:hover": {
                      backgroundColor: "#257BC1",
                      opacity: "70%",
                      color: "white",
                    },
                    "&.Mui-selected": {
                      backgroundColor: "#257BC1",
                      color: "white",
                      fontWeight: "bold",
                    },
                    "&.Mui-selected:hover": {
                      backgroundColor: "#257BC1",
                      color: "white",
                    },
                  },
                }}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
}
